export default __webpack_public_path__ + "static/media/img_baseCottonEars_flowers.f8bbbc7b.jpg";